import React, { useState } from 'react'
import { arrayToOptions } from 'Utilities/selectOptions'
import { uniqBy, map } from 'lodash'

import { defaultApplicationFilters } from '../Filters'
import ApplicationSummary from './Summary'
import SoftwareReportContext from '../SoftwareReportContext'

const CloudCoreSoftwareApplicationsReport = ({ licensableSoftware, licensableSoftwareGroups, software }) => {
  const [filters, changeFilters] = useState(defaultApplicationFilters)
  const toggleSummary = (showSummary = true, currentView) => changeFilters({ ...filters, showSummary })
  const showNonSummarisedData = (filter, chosenOption) => changeFilters({ filters: { ...filters, [filter]: [chosenOption] } })
  const filterOptions = {
    customers: uniqBy(map(software, app => ({ value: app.viaje_client_id, label: app.customer_name })), 'label'),
    licensableSoftware: arrayToOptions(licensableSoftware),
    licensableSoftwareGroups: arrayToOptions(licensableSoftwareGroups),
    applicationEditions: arrayToOptions(map(software, 'edition')),
    regions: [...arrayToOptions(map(software, 'region_name')), { label: 'No region', value: null }]
  }

  return (
    <SoftwareReportContext.Provider value={{ filterOptions, filters, changeFilters, showNonSummarisedData, toggleSummary }}>
      <ApplicationSummary data={software} />
    </SoftwareReportContext.Provider>
  )
}

export default CloudCoreSoftwareApplicationsReport
